<button
  [ngClass]="{
    isSelected: type === FilterType.Chips || isSelected,
    isSelectedNoCheckmark: isSelected,
  }"
  [attr.data-type]="type"
  [disabled]="disabled"
  (click)="selectFilter()"
>
  {{ label }}
</button>
